"use client";

import { useEffect, useState } from "react";
import { ArrowLeft, MoreVertical, Pencil, Trash2 } from "lucide-react";
import "./dictionary.css";
import useDictionaryStore from "../../store/useDictionaryStore";
import useUserStore from "../../store/useUserStore";

export default function MedicalDictionary() {
  const [entries, setEntries] = useState({});
  const [newGeneralTerm, setNewGeneralTerm] = useState("");
  const [newMedicalTerm, setNewMedicalTerm] = useState("");
  const [editingEntry, setEditingEntry] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const { dictionary, fetchDictionaryData, updateDictionary } =
    useDictionaryStore();
  const { isMobile, activePage, setActivePage } = useUserStore();

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  useEffect(() => {
    setEntries(dictionary);
  }, [dictionary]);

  console.log(entries);

  const handleAddEntry = () => {
    if (newGeneralTerm && newMedicalTerm) {
      const updatedEntries = {
        [newGeneralTerm]: newMedicalTerm, 
        ...entries
      };
      updateDictionary(updatedEntries);
      setEntries(updatedEntries);
      setNewGeneralTerm("");
      setNewMedicalTerm("");
    }
  };

  const handleEditEntry = (index, key, value) => {
    setEditingEntry(index+1);
    setNewGeneralTerm(key);
    setNewMedicalTerm(value);
    setOpenMenuId(null);
  };

  const handleUpdateEntry = () => {
    if (editingEntry&& newGeneralTerm && newMedicalTerm) {
      const entriesArray = Object.entries(entries);
      if (editingEntry > 0 && editingEntry <=entriesArray.length) {
        entriesArray[editingEntry-1] = [newGeneralTerm, newMedicalTerm];
      }
      const updatedEntries = Object.fromEntries(entriesArray);

      updateDictionary(updatedEntries);
      setEntries(updatedEntries);
      setEditingEntry(null);
      setNewGeneralTerm("");
      setNewMedicalTerm("");
    }
  };

  const handleDeleteEntry = (index) => {
    const entriesArray = Object.entries(entries);

    if (index >= 0 && index < entriesArray.length) {
      entriesArray.splice(index, 1);
    }

    const updatedEntries = Object.fromEntries(entriesArray);
    updateDictionary(updatedEntries);
    setEntries(updatedEntries);
    setOpenMenuId(null);
  };

  const handleCancelEdit = () => {
    setEditingEntry(null);
    setNewGeneralTerm("");
    setNewMedicalTerm("");
  };

  return (
    <div
      className={`medicalDictionary ${
        isMobile
          ? activePage === "dictionary"
            ? "dictionary-mobile"
            : "dictionary-mobile"
          : " "
      }`}
    >
      <div className="dictionaryHeader">
        <div className="arrow-wrapper">
          {isMobile && (
            <button
              className="arrow-btn"
              onClick={() => setActivePage("sidebar")}
            >
              <ArrowLeft />
            </button>
          )}
          <h1>Medical Dictionary</h1>
        </div>
        <span className="recordCount">
          {Object.keys(entries).length} Records
        </span>
      </div>

      <div className="inputSection">
        <div className="input-container">
          <div className="inputGroup">
            <label>General Term</label>
            <input
              type="text"
              placeholder="Enter general term here"
              value={newGeneralTerm}
              onChange={(e) => setNewGeneralTerm(e.target.value)}
            />
          </div>
          <div className="inputGroup">
            <label>Medical Term</label>
            <input
              type="text"
              placeholder="Enter medical term here"
              value={newMedicalTerm}
              onChange={(e) => setNewMedicalTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="input-buttons">
          {(editingEntry)? (
            <div className="buttonGroup">
              <button className="cancelButton" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="addButton" onClick={handleUpdateEntry}>
                Update
              </button>
            </div>
          ) : (
            <button className="addButton" onClick={handleAddEntry}>
              Add to dictionary
            </button>
          )}
        </div>
      </div>

      <div className="dictionaryContent">
        <div className="tableHeader">
          <div className="idColumn">ID</div>
          <div className="termColumn">General term</div>
          <div className="termColumn">Medical term</div>
          <div className="actionColumn"></div>
        </div>

        <div className="tableBody">
          {Object.entries(entries).map(([key, value], index) => (
            <div key={index} className="tableRow">
              <div className="idColumn">{index+1}</div>
              <div className="termColumn">{key}</div>
              <div className="termColumn">{value}</div>
              <div className="actionColumn">
                <div className="menuContainer">
                  <button
                    className="actionButton"
                    onClick={() =>
                      setOpenMenuId(openMenuId === key ? null : key)
                    }
                  >
                    <MoreVertical size={16} />
                  </button>
                  {openMenuId === key && (
                    <div className="dropdownMenu">
                      <button
                        className="menuItem"
                        onClick={() => handleEditEntry(index, key, value)}
                      >
                        <Pencil size={14} />
                        <span>Edit</span>
                      </button>
                      <button
                        className="menuItem"
                        onClick={() => handleDeleteEntry(index)}
                      >
                        <Trash2 size={14} />
                        <span>Delete</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
